"use client";

import Link from "next/link";


export default function PageInfoLoadError() {

    return (
        <section>

            <div className="w-full font-poppins text-lg sm:text-xl lg:text-2xl text-center px-4">{"Erro ao carregar Informação da página"}</div>
            <div className="w-full font-poppins text-lg sm:text-xl lg:text-2xl text-center p-4 sm:p-6 lg:p-10">
                <Link href="#" onClick={() => "js:window.location.reload();"} className="bg-red-500 px-4 py-2 sm:px-6 sm:py-3 text-white rounded-xl" style={{ color: "#fffff !important" }} >Recarregar</Link>
            </div>
        </section>
    );
};